import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';

import css from './CommunitySponsorBadge.module.css';

/**
 * Community Sponsor pill (mock-inspired badge chrome).
 *
 * @component
 */
const CommunitySponsorBadge = props => {
  const { className, size = 'default' } = props;
  const classes = classNames(css.root, className, {
    [css.sizeCompact]: size === 'compact',
  });

  return (
    <span className={classes}>
      <svg
        className={css.icon}
        width="13"
        height="13"
        viewBox="0 0 24 24"
        aria-hidden
        focusable="false"
      >
        <path className={css.shield} d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5z" />
        <path
          className={css.check}
          d="m9 12 2 2 4-4"
          fill="none"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className={css.label}>
        <FormattedMessage id="ProfilePage.communitySponsorBadge" />
      </span>
    </span>
  );
};

export default CommunitySponsorBadge;
